let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9pHFU")).then(() => parcelRequire('aGxmN'));